module.exports = __webpack_public_path__ + "img/img2.d71410f.png";